// import axios from 'axios';
import config from './config';
var CelaneseAPI = {
    config: config,
    api: function(url, data, method, opts) {
        let params = {
            data: data,
            method: method,
            credentials: 'include',
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
                'sessiontoken': localStorage.getItem('sessiontoken')
            }
        };
        url = url + (url.indexOf('?') >= 0 ? '&' : '?') + Date.now();
        params.body = (opts && opts.isUpload) ?  data : JSON.stringify(data);
        if(opts && opts.isBlob) {
            return fetch(this.config.API.baseURL + (url.indexOf('/') >= 0 ? url : '/' + url), params).then(resp => {
                return resp.blob();
            }).catch(e => {
                // throw
            });
        } else {
            return fetch(this.config.API.baseURL + (url.indexOf('/') >= 0 ? url : '/' + url), params).then(data => data.json()).then(resp => {
                window.currentServerTimestamp = resp.currentServerTimestamp;
                if (resp.sessionToken) {
                    localStorage.setItem('sessiontoken', resp.sessionToken);
                }
                return resp;
            }).catch(e => {
                // throw
            });
        }
    },
    getBlob: function (url, data) {
        return this.api(url, data, 'GET', { isBlob: true});
    },
    post: function(url, data, opts){
        return this.api(url, data, 'POST', opts);
    },
    get: function(url, data){
        return this.api(url, data, 'GET');
    },
    patch: function(url, data){
        return this.api(url, data, 'PATCH');
    },
    delete: function(url, data){
        return this.api(url, data, 'DELETE');
    }
};
module.exports = CelaneseAPI;


// WEBPACK FOOTER //
// ./src/services.js